import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { getMediaPath } from 'app/functions';
import { FontFamily, palette } from 'common/theme';
import Number0Icon from 'assets/HotYoter/number0.svg';
import Number1Icon from 'assets/HotYoter/number1.svg';
import Number2Icon from 'assets/HotYoter/number2.svg';
import NumberGoldIcon from 'assets/HotYoter/numbergold.svg';
import NumberBaseIcon from 'assets/HotYoter/Elips Numb Base.svg';

const NUMBER_BADGE_ICONS = {
    0: Number0Icon,
    1: Number1Icon,
    2: Number2Icon,
};

export const getBadgeDimensions = (circleSize) => {
    const badgeWidth = (97 / 40) * circleSize;
    const badgeHeight = (119 / 40) * circleSize;

    return {
        badgeWidth,
        badgeHeight,
        circleLeft: (39.082 / 97) * badgeWidth,
        circleTop: (36.4766 / 119) * badgeHeight,
        circleWidth: (40 / 97) * badgeWidth,
        circleHeight: (40 / 119) * badgeHeight,
        numberFontSize: Math.round(16 * (circleSize / 40)),
        numberLineHeight: Math.round(24 * (circleSize / 40)),
    };
};

export const EligiblesBadge = ({
    count,
    circleSize,
    alignSelf = 'center',
    testID = 'hot-yoter-eligibles-badge',
}) => {
    const dimensions = useMemo(
        () => getBadgeDimensions(circleSize),
        [circleSize],
    );

    const isGoldBadge = count === 'gold';
    const hasEmbeddedBadge = count === 0 || count === 1 || count === 2;
    const BadgeIcon = isGoldBadge
        ? NumberGoldIcon
        : hasEmbeddedBadge
            ? NUMBER_BADGE_ICONS[count]
            : NumberBaseIcon;

    const badgeImageStyle = useMemo(() => (
        isGoldBadge
            ? {
                position: 'absolute',
                display: 'block',
                top: 0,
                left: 0,
                width: dimensions.circleWidth,
                height: dimensions.circleHeight,
                maxWidth: 'none',
            }
            : {
                position: 'absolute',
                display: 'block',
                top: -dimensions.circleTop,
                left: -dimensions.circleLeft,
                width: dimensions.badgeWidth,
                height: dimensions.badgeHeight,
                maxWidth: 'none',
            }
    ), [dimensions, isGoldBadge]);

    return (
        <Box
            testId={testID}
            dir="ltr"
            sx={{
                flexShrink: 0,
                alignSelf,
                width: dimensions.circleWidth,
                height: dimensions.circleHeight,
                minWidth: dimensions.circleWidth,
                minHeight: dimensions.circleHeight,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: dimensions.circleWidth,
                    height: dimensions.circleHeight,
                    overflow: 'hidden',
                    borderRadius: '50%',
                }}
            >
                <Box
                    component="img"
                    src={getMediaPath(BadgeIcon)}
                    alt=""
                    style={badgeImageStyle}
                />
                {!hasEmbeddedBadge && !isGoldBadge ? (
                    <Box
                        component="span"
                        testId={`${testID}-count`}
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontFamily: FontFamily.extraBold,
                            fontSize: dimensions.numberFontSize,
                            lineHeight: `${dimensions.numberLineHeight}px`,
                            textAlign: 'center',
                            background: `linear-gradient(to top, ${palette.gradientStart} 10%, ${palette.gradientMiddle} 73%, ${palette.gradientEnd} 100%)`,
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        {count}
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
};
